import { ApiResponse, PaginatedResponse } from "../types/common";
import {
  News,
  CreateNewsRequest,
  UpdateNewsRequest,
  NewsFilter,
} from "../types/landing";
import api from "./api";

// News CRUD Operations
export const newsService = {
  getAllNews: async (
    filters: NewsFilter = {}
  ): Promise<PaginatedResponse<News>> => {
    try {
      const params = new URLSearchParams();

      if (filters.page) params.append("page", filters.page.toString());
      if (filters.limit) params.append("limit", filters.limit.toString());
      if (filters.search) params.append("search", filters.search);
      if (filters.status) params.append("status", filters.status);
      if (filters.category) params.append("category", filters.category);

      const response = await api.get(
        `/landing/news/admin?${params.toString()}`
      );

      const data = response as any;
      return {
        success: data.success,
        data: data.data || [],
        pagination: {
          currentPage: data.currentPage || 1,
          totalPages: data.totalPages || 1,
          totalItems: data.total || 0,
          hasNext: (data.currentPage || 1) < (data.totalPages || 1),
          hasPrev: (data.currentPage || 1) > 1,
        },
      };
    } catch (error) {
      console.error("Error fetching news:", error);
      throw error;
    }
  },

  getNewsById: async (id: string): Promise<ApiResponse<News>> => {
    try {
      const response = await api.get(`/landing/news/${id}`);
      return response as any;
    } catch (error) {
      console.error("Error fetching news by ID:", error);
      throw error;
    }
  },

  createNews: async (
    newsData: CreateNewsRequest
  ): Promise<ApiResponse<News>> => {
    try {
      const response = await api.post("/landing/news", newsData);
      return response as any;
    } catch (error) {
      console.error("Error creating news:", error);
      throw error;
    }
  },

  updateNews: async (
    id: string,
    newsData: UpdateNewsRequest
  ): Promise<ApiResponse<News>> => {
    try {
      const response = await api.put(`/landing/news/${id}`, newsData);
      return response as any;
    } catch (error) {
      console.error("Error updating news:", error);
      throw error;
    }
  },

  deleteNews: async (id: string): Promise<ApiResponse<null>> => {
    try {
      const response = await api.delete(`/landing/news/${id}`);
      return response as any;
    } catch (error) {
      console.error("Error deleting news:", error);
      throw error;
    }
  },

  publishNews: async (id: string): Promise<ApiResponse<News>> => {
    try {
      const response = await api.patch(`/landing/news/${id}/publish`);
      return response as any;
    } catch (error) {
      console.error("Error publishing news:", error);
      throw error;
    }
  },

  unpublishNews: async (id: string): Promise<ApiResponse<News>> => {
    try {
      const response = await api.patch(`/landing/news/${id}/unpublish`);
      return response as any;
    } catch (error) {
      console.error("Error unpublishing news:", error);
      throw error;
    }
  },
};
